export const formatBytes = (value: number) => {
    if (!value) {
        return '0 B';
    }

    const units = ['B', 'KB', 'MB', 'GB'];
    const power = Math.min(Math.floor(Math.log(value) / Math.log(1024)), units.length - 1);
    const size = value / Math.pow(1024, power);

    return `${power === 0 ? size : size.toFixed(1)} ${units[power]}`;
};
